import React from "react";

const Feeding = () => {
  return (
    <div className="space-y-8 max-w-full overflow-hidden">
      {/* Compact Metrics Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5">
        {/* Card 1 */}
        <div className="bg-white border border-gray-100 rounded-3xl p-5 shadow transition-all">
          <div className="flex justify-between">
            <div>
              <div className="text-xs text-gray-500">CURRENT ACTIVITY</div>
              <div className="text-4xl font-semibold text-emerald-700 mt-2">ACTIVE</div>
            </div>
            <div className="text-5xl">🐟</div>
          </div>
          <div className="mt-5 h-2 bg-gray-100 rounded-full">
            <div className="h-full w-[92%] bg-emerald-500 rounded-full" />
          </div>
          <div className="text-xs text-emerald-600 mt-1.5">92% feed motion</div>
        </div>

        {/* Card 2 */}
        <div className="bg-white border border-gray-100 rounded-3xl p-5 shadow transition-all">
          <div className="text-xs text-gray-500">SESSIONS TODAY</div>
          <div className="flex items-baseline gap-1 mt-2">
            <span className="text-4xl font-semibold">4</span>
            <span className="text-2xl text-gray-300">/4</span>
          </div>
          <div className="flex gap-1 mt-6">
            {[1,1,1,1].map((_, i) => (
              <div key={i} className="flex-1 h-5 bg-emerald-500 rounded" />
            ))}
          </div>
          <div className="text-xs text-green-600 mt-1">100% on schedule</div>
        </div>

        {/* Card 3 - Mini Bar Chart */}
        <div className="bg-white border border-gray-100 rounded-3xl p-5 shadow transition-all">
          <div className="text-xs text-gray-500">AVG DURATION</div>
          <div className="text-4xl font-semibold mt-2">24 min</div>
          <div className="h-16 flex items-end gap-2 mt-5">
            {[18,26,23,29].map((v,i) => (
              <div key={i} className="flex-1 flex flex-col justify-end">
                <div className="bg-teal-500 rounded-t" style={{height: `${(v/32)*100}%`}} />
                <div className="text-[10px] text-gray-400 text-center mt-1">{v}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Card 4 - Progress Circle */}
        <div className="bg-white border border-gray-100 rounded-3xl p-5 shadow transition-all flex flex-col items-center">
          <div className="text-xs text-gray-500 w-full">WORKER PRESENCE</div>
          <div className="relative w-20 h-20 mx-auto mt-3">
            <svg className="w-full h-full -rotate-90" viewBox="0 0 36 36">
              <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#e5e7eb" strokeWidth="4" />
              <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#10b981" strokeWidth="4" strokeDasharray="100, 100" />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center font-semibold text-3xl text-emerald-700">100</div>
          </div>
          <div className="text-xs text-green-600 text-center mt-1">All sessions</div>
        </div>

        {/* Card 5 */}
        <div className="bg-white border border-gray-100 rounded-3xl p-5 shadow transition-all flex flex-col justify-between">
          <div>
            <div className="text-xs text-gray-500">NEXT FEEDING</div>
            <div className="text-4xl font-semibold mt-2">14:30</div>
          </div>
          <div className="text-xs bg-amber-100 text-amber-700 px-4 py-1 rounded-3xl w-fit">2h 47m</div>
        </div>
      </div>

      {/* Compact Timeline */}
      <div className="bg-white border border-gray-100 rounded-3xl p-6 shadow">
        <div className="flex justify-between text-sm mb-5">
          <div className="font-medium">TODAY’S FEEDING TIMELINE</div>
          <div className="text-emerald-600">AI validated • 4 sessions</div>
        </div>

        <div className="space-y-7 relative pl-7">
          {[
            { time: "06:15", dur: "22 min", motion: "98%", ai: "Human + Feed motion" },
            { time: "09:30", dur: "26 min", motion: "100%", ai: "Timestamp match" },
            { time: "11:42", dur: "23 min", motion: "99%", ai: "Full compliance" },
            { time: "14:30", dur: "—", motion: "—", ai: "Scheduled" },
          ].map((s, i) => (
            <div key={i} className="flex items-start gap-6 relative">
              <div className="absolute left-0 top-2 w-3.5 h-3.5 bg-emerald-600 rounded-full z-10" />
              {i < 3 && <div className="absolute left-1.5 top-6 bottom-0 w-px bg-gray-100" />}
              
              <div className="flex-1 bg-gray-50 rounded-2xl p-5">
                <div className="flex items-center justify-between">
                  <div className="font-medium">{s.time}</div>
                  <div className="text-xl font-semibold text-teal-600">{s.dur}</div>
                </div>
                <div className="flex gap-8 mt-4 text-xs">
                  <div>
                    <div className="text-gray-500">MOTION</div>
                    <div className="font-semibold text-emerald-700">{s.motion}</div>
                  </div>
                  <div>
                    <div className="text-gray-500">AI CONFIDENCE</div>
                    <div className="h-1.5 bg-gray-200 rounded mt-1 w-24">
                      <div className="h-full bg-emerald-500 rounded" style={{width: s.motion}} />
                    </div>
                  </div>
                </div>
                <div className="text-xs text-gray-500 mt-3">{s.ai}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Compact AI Confidence */}
      <div className="bg-white border border-gray-100 rounded-3xl p-6 shadow">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[
            { label: "HUMAN PRESENCE", pct: "98%", width: "98%" },
            { label: "FEED THROWING", pct: "100%", width: "100%" },
            { label: "TIME STAMP", pct: "99%", width: "99%" },
          ].map((d, i) => (
            <div key={i}>
              <div className="flex justify-between text-xs mb-2">
                <span className="text-gray-500">{d.label}</span>
                <span className="font-medium text-emerald-700">{d.pct}</span>
              </div>
              <div className="h-2 bg-gray-100 rounded-full">
                <div className="h-full bg-emerald-500 rounded-full" style={{width: d.width}} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Feeding;